import { render, staticRenderFns } from "./_BookList.vue?vue&type=template&id=577d3bc8"
import script from "./_BookList.vue?vue&type=script&lang=js"
export * from "./_BookList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports